import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";

import "../styles/testimonial.css";
const Testimonial = () => {
  return (
    <>
      <div className="testimonialBox">
        <h3> Testimonials</h3>
        <Carousel
          autoPlay={true}
          interval={15000}
          infiniteLoop={true}
          showThumbs={false}
          showStatus={false}
          swipeable={false}
        >
          <div>
            "I booked a course of therapy with Georgina to try & help with my
            low self-esteem & lack of motivation. I must admit I was a little
            sceptical at first. However, Georgina’s calm, relaxed manner put me
            at ease from the first session. By the third visit I really started
            to notice a positive difference in my attitude & way of thinking.
            It’s made such a big difference. The sessions were excellent & I
            would recommend GTW Hypnotherapy to everyone."
          </div>
          <div>
            "Georgina is such a warm & approachable person & great at listening.
            My mindset needed some guidance & I felt reassured to be able to
            talk openly & also relax in the environment. The transformation in
            my thought process has been staggering & I would highly recommend
            GTW to anyone going through challenges in life. Georgina is highly
            professional & passionate about helping others."
          </div>
          <div>
            "I went to see Georgina for support with my anxiety & confidence.
            They had both deteriorated due to not feeling like I was good
            enough…my looks, the way I dress & feeling like people were always
            judging me. I secluded myself away from going out & being sociable.
            Since having regular sessions with Georgina I owe her the biggest
            thank you! I had tried to battle my mental health for a couple of
            years & this weekend was the first time in those two years that I
            went away for the weekend! I’m so proud that I conquered my fears &
            I felt free for the first time in a long time. Georgina, thank you
            so much for supporting & helping me through a really tough time."
          </div>
          <div>
            "Georgina made me feel relaxed & comfortable from our first
            introductory meeting. Being new to any therapy, it was important for
            me to understand the process & feel confident in the person I was
            working with. Georgina was able to explain quite simply how
            hypnotherapy can work. She listened without judgement & has given me
            a toolkit that I can use with myself & those around me to ensure
            that I am feeling confident & positive in any situation. And I can
            now go to the shop by myself…hurrah!"
          </div>
          <div>
            "The hypnotherapy treatment I have had from Georgina has been life
            changing. The benefits have extended beyond helping me achieve some
            significant goals ina relatively short space of time. Overall my
            wellbeing & mental health has substantially improved. Georgina has
            been excellent & her calm, gentle, friendly & professional approach
            is very easy to work with. She was also able to accommodate my
            difficult schedule & be flexible about session times."
          </div>
          <div>
            "I got in contact with Georgina for some help with my anxiety &
            stress. I felt I needed some tools to help me cope when under
            pressure & feeling overwhelmed. Even from the first session I felt
            very at ease & Georgina explained what the sessions would entail &
            how many she thought I may need. I found this solution focused based
            therapy really positive & it really helped me to change my mindset &
            my perception of things. I always looked forward to my sessions &
            within 5-6 sessions I had already felt a dramatic difference in my
            behaviour & ability to cope when feeling overwhelmed. Thank you
            Georgina!"
          </div>
          <div>
            My 17 year old daughter saw Georgina last year for 6 sessions for
            anxiety related issues. I didn’t know which way to turn until I
            decided to try hypnotherapy as a quick fix. Georgina turned her
            world around. My daughter is a different person. So happy, confident
            and is actually now loving life. We owe her so very much. I
            recommend GTW with all my heart. Such a lovely, kind person which
            shone through from the first minute and made us feel so comfortable.
            Thank you Georgina.
          </div>
          <div>
            Georgina has been amazing in helping me with my phobia of sick, I’ve
            suffered ever since I was a child with this &amp; am now at 26 so
            much happier &amp; able to deal with this. It was one of the best
            decisions I made to see Georgina &amp; I would highly recommend to
            anyone else who is considering overcoming their anxieties or fears!
          </div>
          <div>
            My mum and I went to see Georgina due to an unexpected &amp;
            unbearable change in our lives. The moment we started going to see
            Georgina we could see a remarkable difference in our new mindset.
            The lovely lady has changed our lives for the better &amp; has
            pointed us in the right direction to help us carry on in life, not
            by making us forget the past but by working alongside it to see the
            bright side of things. Thank you so much for having patience &amp;
            kindness for us &amp; working extremely hard to make sure we achieve
            our goal. We don’t know where we would be without you Georgina,
            thank you so much.
          </div>
          <div>
            Georgina is very relatable &amp; friendly. She made me feel very
            comfortable from the very first meeting. She has hugely helped me to
            be able to move forward in my life. I honestly don’t know where I’d
            be without her help. Thanks again Georgina, I 100% recommend you to
            anyone.
          </div>
          <div>
            Georgina is a fantastic therapist. I’ve had both 1 to 1 sessions
            &amp; the group relaxation therapy now &amp; have not been
            disappointed. So personable &amp; easy to speak to, you come away
            feeling so positive.
          </div>
          <div>
            I had such fab sessions with Georgina. I left every time feeling so
            relaxed &amp; like a weight had been lifted off my shoulders. The
            perfect place to go for pretty much anything that you need to ‘work
            on’.
          </div>
          <div>
            I went to see Georgina as I was dealing with frequent panic attacks
            &amp; didn’t know why. From my first meeting, she made me feel very
            calm &amp; relaxed. She explained how the mind works &amp; how the
            attacks occur. I booked a course of sessions &amp; have seen a big
            improvement in my anxiety. I would recommend Georgina 100%.
          </div>
          <div>
            I walked into GTW Hypnotherapy without a clue what I wanted I just
            knew I had lost myself in the past 16 months under a pile of
            stress/worry &amp; anxiety. Even after the first session Georgina
            made me see why my brain wasn’t really in the right place. 6
            sessions later I found ME again and I haven’t looked back. My
            confidence levels have improved, stress bucket much lighter &amp;
            anxiety gone. Highly recommend GTW Hypnotherapy
          </div>
          <div>
            I took my 7yr old son for a set of sessions with Georgina for an
            eating disorder (ARFID). The plan was to work on his confidence so
            that in time he would have the confidence to try foods. Georgina is
            the most calming, lovely human anyone could wish to meet. She put
            both of us at ease but mainly my son. The difference in our son’s
            confidence is utterly incredible. He hated everything about school
            but just this week has come home not only once but twice and said
            that he had a REALLY good day at school. He didn&#39;t know why, but
            he said he felt REALLY happy. His teacher has noticed big changes in
            his behaviour too &amp; he now communicates and talks through things
            that are troubling him instead of it all building up inside. If you
            are in doubt, don&#39;t be. Georgina is incredibly good at what she
            does &amp; I have no hesitation in highly recommending her to
            anyone!
          </div>
          <div>
            Having struggled with confidence, positivity &amp; mild anxiety in
            the professional work-place for many years, and finally deciding to
            do something about it in order to support my future aspirations, my
            wife recommended I talk to Georgina. From the very first
            consultation I was put at ease by Georgina, who listened to the
            areas I wanted to tackle &amp; reassured me that my issues are quite
            common &amp; could be improved upon if I was prepared to engage with
            the sessions. I almost instantly felt relief &amp; reassurance. From
            the very first session with Georgina I, &amp; others who know me,
            have noticed a marked improvement in my confidence &amp; positivity.
            The sessions have had a really positive impact on many areas of not
            only my work life but also my personal life. I highly recommend
            Georgina &amp; personally would not go anywhere else. I wish you
            luck for your own &#39;better you&#39; journey.
          </div>
        </Carousel>
      </div>
    </>
  );
};

export default Testimonial;
